






















import SidebarItem from "./SidebarItem.vue";
import { Component, Vue } from "@/common";

@Component({
  components: {
    SidebarItem
  }
})
export default class Sidebar extends Vue {
  get sidebar() {
    return this.$store.state.app.sidebar;
  }

  get menus() {
    return this.$store.state.app.menus;
  }

  get isCollapse() {
    return !this.sidebar.opened;
  }
}
